<template>
  <samp>{{ minuteVal }}</samp>
</template>

<script>
export default {
  props: {
    endTime: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      minuteVal: ''
    };
  },
  watch: {
    endTime() {
      window.clearInterval(this.timer);
      this.startTiming(1);
    }
  },
  created() {
    window.clearInterval(this.timer);
    this.startTiming(1);
  },
  methods: {
    startTiming(val) {
      const vm = this;
      const mss = (new Date().getTime() - new Date(vm.endTime).getTime() + 2000);
      let day = Math.floor(mss / 1000 / 60 / 60 / 24);
      let hour = Math.floor(mss / 1000 / 60 / 60);
      let minute = Math.floor(mss / 1000 / 60);
      let second = Math.round((mss % (1000 * 60)) / 1000);
      if (val == 1) {
        vm.timer = setInterval(() => {
          if (second >= 0) {
            second += 1;
          }
          if (second >= 60) {
            second = 0;
            minute += 1;
          }
          if (minute >= 60) {
            minute = 0;
            hour += 1;
          }
          if (hour >= 24) {
            hour = 0;
            day += 1;
          }
          if (day > 1) {
            if (day > 99) {
              vm.minuteVal = `超${day}天`;
            } else {
              vm.minuteVal = `超${day}天${hour < 10 ? (`0${hour}`) : hour}:${minute < 10 ? (`0${minute}`) : minute}:${second < 10 ? (`0${second}`) : second}`;
            }
          } else {
            vm.minuteVal = `超${hour < 10 ? (`0${hour}`) : hour}:${minute < 10 ? (`0${minute}`) : minute}:${second < 10 ? (`0${second}`) : second}`;
          }
        }, 1000);
      } else {
        window.clearInterval(vm.timer);
      }
    }
  }
};
</script>
